/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AWSConfigSchema
 */
export interface AWSConfigSchema {
    /**
     * 
     * @type {string}
     * @memberof AWSConfigSchema
     */
    defaultRegion: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AWSConfigSchema
     */
    supportedRegions: Array<string>;
}

/**
 * Check if a given object implements the AWSConfigSchema interface.
 */
export function instanceOfAWSConfigSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "defaultRegion" in value;
    isInstance = isInstance && "supportedRegions" in value;

    return isInstance;
}

export function AWSConfigSchemaFromJSON(json: any): AWSConfigSchema {
    return AWSConfigSchemaFromJSONTyped(json, false);
}

export function AWSConfigSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AWSConfigSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'defaultRegion': json['default_region'],
        'supportedRegions': json['supported_regions'],
    };
}

export function AWSConfigSchemaToJSON(value?: AWSConfigSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'default_region': value.defaultRegion,
        'supported_regions': value.supportedRegions,
    };
}

